"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioList = void 0;
var react_1 = __importStar(require("react"));
var constants_1 = require("../../../constants");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var molecules_1 = require("../../molecules");
var RadioList = function (_a) {
    var _b = _a.wrapperClass, wrapperClass = _b === void 0 ? 'tw-flex tw-w-full tw-overflow-x-auto tw-no-scrollbar tw-gap-6' : _b, _c = _a.wrapperStyle, wrapperStyle = _c === void 0 ? '' : _c, _d = _a.list, list = _d === void 0 ? [] : _d, _e = _a.customSelectedIndex, customSelectedIndex = _e === void 0 ? 0 : _e, _f = _a.controlled, controlled = _f === void 0 ? false : _f, _g = _a.value, value = _g === void 0 ? -1 : _g, _h = _a.onSelect, onSelect = _h === void 0 ? constants_1.defaultFn : _h, _j = _a.buttonWrapperStyle, buttonWrapperStyle = _j === void 0 ? '' : _j, buttonWrapperClassName = _a.buttonWrapperClassName, _k = _a.radioButtonProps, radioButtonProps = _k === void 0 ? {} : _k, _l = _a.isClearable, isClearable = _l === void 0 ? true : _l, id = _a.id, eventCallback = _a.eventCallback;
    var _m = react_1.useState(customSelectedIndex), selectedIndex = _m[0], setSelectedIndex = _m[1];
    var handleSelect = function (itemIndex) {
        setSelectedIndex(itemIndex);
        onSelect(list[itemIndex], itemIndex);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.RADIO_LIST_CLICK, { id: id, itemIndex: itemIndex, list: list });
    };
    return (react_1.default.createElement("div", { className: wrapperClass + " " + wrapperStyle, "data-testid": "radio-list-wrapper-" + id }, list === null || list === void 0 ? void 0 : list.map(function (listItem, index) {
        var _a, _b;
        return (react_1.default.createElement(molecules_1.RadioButton, __assign({ key: (_a = listItem === null || listItem === void 0 ? void 0 : listItem.value) !== null && _a !== void 0 ? _a : index, wrapperStyle: buttonWrapperStyle, wrapperClassName: buttonWrapperClassName }, radioButtonProps, { checked: controlled ? index === value : index === selectedIndex, onSelect: function () { return handleSelect(index); }, label: listItem === null || listItem === void 0 ? void 0 : listItem.label, isClearable: isClearable, id: "radio-list-" + ((_b = listItem === null || listItem === void 0 ? void 0 : listItem.value) !== null && _b !== void 0 ? _b : index) + "-" + id, eventCallback: eventCallback })));
    })));
};
exports.RadioList = RadioList;
